<!------------ START TEMPLATE ------------>
<template>
  <div>
    <!------------ START FORM ------------>
    <vs-card class="mb-6">
      <form role="form" @submit.stop.prevent="buscar">
        <!-----============================ OBS: No status deve ter um campo SELECT que irá trazer as opções criadas pelo usuário na parte cadastro de Status do Menu USUARIO  ==================------->
        <div :class="`vx-row ${filtroAvancado == true ? '' : 'pb-6 mb-0'}`">
          <div :class="`vx-col sm:w-1/5 w-full`">
            <span>Placa</span>
            <vs-input
              v-mask="'AAA-#XX#'"
              class="w-full"
              name="Placa"
              id="Placa"
              v-model="formFiltro.placa"
              :state="validateState('Placa')"
              :danger="validateClass('Placa')"
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
            />
          </div>

          <!-- Segurado -->
          <div :class="`vx-col sm:w-1/4 w-full`">
            <span>Nome do Segurado</span>
            <AutoComplete
              customClass="w-full"
              name="Segurado"
              id="Segurado"
              :configAutoComplete="{ model: 'associados', field: 'nome' }"
              v-model="formFiltro.nomeAssociado"
            />
          </div>

          <div class="vx-col sm:w-1/3 w-full">
            <span>Data Inicial</span>
            <vx-input-group class="mb-base">
              <template slot="prepend">
                <v-select
                  style="width: 250px"
                  :options="tiposDatas"
                  v-model="formFiltro.tipoData"
                ></v-select>
              </template>

              <datepicker
                :format="'dd/MM/yyyy'"
                placeholder="DD/MM/YYYY"
                v-model="formFiltro.dataInicial"
              ></datepicker>
            </vx-input-group>
          </div>

          <div class="vx-col sm:w-1/5 w-full">
            <span>Data Final</span>
            <datepicker
              :format="'dd/MM/yyyy'"
              placeholder="DD/MM/YYYY"
              v-model="formFiltro.dataFinal"
            ></datepicker>
          </div>
        </div>
        <div v-if="filtroAvancado == true" class="vx-row pb-10">
          <div :class="`vx-col sm:w-1/4 w-full`">
            <span>Chassi</span>
            <vs-input
              class="w-full"
              name="Chassi"
              id="Chassi"
              v-model="formFiltro.chassi"
              :state="validateState('Chassi')"
              :danger="validateClass('Chassi')"
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
            />
          </div>
          <div :class="`vx-col sm:w-1/4 w-full`">
            <span>Cpf / CNPJ</span>
            <vs-input
              class="w-full"
              name="cpfcnpj"
              id="cpfcnpj"
              v-model="formFiltro.cpfcnpj"
              :state="validateState('cpfcnpj')"
              :danger="validateClass('cpfcnpj')"
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
            />
          </div>
          <div class="vx-col sm:w-1/4 w-full">
            <span>Status Cobrança</span>
            <v-select
              :options="statusCobranca"
              multiple
              name="Status"
              id="Status"
              v-model="formFiltro.statusCobranca"
              :state="validateState('Status')"
              :class="validateClass('Status')"
            ></v-select>
          </div>

          <div class="vx-col sm:w-1/4 w-full">
            <span>Tipo de Boleto</span>
            <v-select
              :options="tiposBoletos"
              multiple
              name="Tipo de Boleto"
              id="Tipo de Boleto"
              v-model="formFiltro.tipoBoleto"
              :reduce="(item) => item.idTipoBoleto"
              label="tipoBoleto"
              :state="validateState('Tipo de Boleto')"
              :class="validateClass('Tipo de Boleto')"
            >
            </v-select>
          </div>
        </div>

        <div v-if="filtroAvancado == true" class="vx-row pb-10">
          <div class="vx-col sm:w-1/6 w-full">
            <span>Forma de Pagamento</span>
            <v-select
              :options="formasPagamento"
              name="Forma de Pagamento"
              id="Forma de Pagamento"
              multiple
              v-model="formFiltro.formaPagamento"
              :state="validateState('Forma de Pagamento')"
              :class="validateClass('Forma de Pagamento')"
            ></v-select>
          </div>

          <div class="vx-col sm:w-1/6 w-full">
            <span>Origem</span>
            <v-select
              :options="origem"
              multiple
              name="Origem"
              id="Origem"
              v-model="formFiltro.origem"
              :state="validateState('Origem')"
              :class="validateClass('Origem')"
            ></v-select>
          </div>

          <div class="vx-col sm:w-1/6 w-full">
            <span>Rateio</span>
            <v-select
              :options="rateios"
              name="Rateio"
              id="Rateio"
              multiple
              v-model="formFiltro.rateio"
              :state="validateState('Rateio')"
              :class="validateClass('Rateio')"
            ></v-select>
          </div>

          <div class="vx-col sm:w-1/4 w-full">
            <span>Status Veículo</span>
            <v-select
              :options="statusVeiculo"
              multiple
              name="Status"
              id="Status"
              v-model="formFiltro.statusVeiculo"
              :state="validateState('Status')"
              :class="validateClass('Status')"
            ></v-select>
          </div>

          <div class="vx-col sm:w-1/4 w-full">
            <span>Status Segurado</span>
            <v-select
              :options="statusAssociado"
              multiple
              name="Status"
              id="Status"
              v-model="formFiltro.statusAssociado"
              :state="validateState('Status')"
              :class="validateClass('Status')"
            ></v-select>
          </div>
        </div>
        <div v-if="filtroAvancado == true" class="vx-row pb-10">
          <div class="vx-col sm:w-1/4 w-full">
            <span>Tipo de Baixa</span>
            <v-select
              :options="tipoBaixa"
              name="Tipo de Baixa"
              id="Tipo de Baixa"
              v-model="formFiltro.tipoBaixa"
              :state="validateState('Tipo de Baixa')"
              :class="validateClass('Tipo de Baixa')"
            ></v-select>
          </div>
          <div class="vx-col sm:w-1/4 w-full">
            <span>Boleto Físico</span>
            <v-select
              :options="boletoFisico"
              name="Boleto Físico"
              id="Boleto Físico"
              v-model="formFiltro.boletoFisico"
              :state="validateState('Boleto Físico')"
              :class="validateClass('Boleto Físico')"
            ></v-select>
          </div>
          <div class="vx-col sm:w-1/4 w-full">
            <span>Usuário</span>
            <v-select
              :options="consultores"
              name="Usuário"
              id="Usuário"
              multiple
              v-model="formFiltro.consultor"
              :state="validateState('Usuário')"
              :class="validateClass('Usuário')"
            ></v-select>
          </div>

          <div class="vx-col sm:w-1/4 w-full">
            <span>Corretora</span>
            <v-select
              :options="regionais"
              name="Corretora"
              id="Corretora"
              multiple
              v-model="formFiltro.regional"
              :state="validateState('Corretora')"
              :class="validateClass('Corretora')"
            ></v-select>
          </div>
        </div>
      </form>
      <div slot="footer" style="margin-top: -3%">
        <br style="clear: both" />
        <vs-row vs-justify="flex-end">
          <vs-button
            color="success"
            type="filled"
            icon-pack="feather"
            icon="icon-search"
            class="mr-3 mb-2"
            @click="buscar"
            >Buscar</vs-button
          >
          <vs-button
            @click="filtroAvancado = !filtroAvancado"
            type="gradient"
            color="dark"
            icon-pack="feather"
            icon="icon-sliders"
          ></vs-button>
          <vs-button
            @click="limparFiltro"
            color="danger"
            type="gradient"
            icon-pack="feather"
            icon="icon-trash-2"
          ></vs-button>
        </vs-row>
      </div>
    </vs-card>
    <!------------ END FORM ------------>
  </div>
</template>
<!------------ END TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import locale from './../../locale';
import Datepicker from 'vuejs-datepicker';
import * as lang from 'vuejs-datepicker/src/locale';
import vSelect from 'vue-select';
import service from '../../services';
import AutoComplete from '../../components/autocomplete/AutoComplete';
import jwt from 'jsonwebtoken';

export default {
  props: {
    sideBar: {
      type: Boolean,
    },
    dados: {
      type: Object,
    },
    vistoria: {
      type: Boolean,
    },
    b2c: {
      type: Boolean,
    },
  },
  watch: {},
  data() {
    return {
      aguardeCadastro: false,
      idEmpresa: null,
      id_usuario: null,
      formasPagamento: [],
      statusCobranca: [],
      rateios: [],
      statusVeiculo: [],
      statusAssociado: [],
      consultores: [],
      regionais: [],
      tiposBoletos: [],
      languages: lang,
      filtroAvancado: false,
      boletoFisico: ['Sim', 'Não'],
      tipoBaixa: ['Automática', 'Manual'],
      tiposDatas: [
        'Data Emissão',
        'Data Vencimento',
        'Data Vencimento Original',
        'Data Pagamento',
      ],
      origem: ['SGA', 'Registro Financeiro'],
      estado: null,
      funcoesValicao: null,
      formFiltro: {
        idEmpresa: null,
        placa: null,
        nomeAssociado: null,
        cpfcnpj: null,
        chassi: null,
        status: null,
        tipo: null,
        formaPagamento: null,
        origem: null,
        tipoData: 'Data Emissão',
        dataInicial: this.dataInicio(),
        dataFinal: new Date(),
        statusVeiculo: null,
        statusAssociado: null,
        boletoFisico: null,
        tipoBaixa: null,
        tipoBoleto: null
      },
    };
  },
  methods: {
    limparFiltro() {
      this.formFiltro = {
        placa: null,
        nomeAssociado: null,
        cpfcnpj: null,
        chassi: null,
        status: null,
        tipo: null,
        formaPagamento: null,
        origem: null,
        tipoData: 'Data Emissão',
        dataInicial: this.dataInicio(),
        dataFinal: new Date(),
        statusVeiculo: null,
        statusAssociado: null,
        boletoFisico: null,
        tipoBaixa: null,
      };
      this.buscar();
    },
    dataInicio() {
      var a = new Date();
      var b = a.setDate(a.getDate() - 1);
      return b;
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },

    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll('g', {}, `${model}/list/`).then((res) => {
        res.data.forEach((element) => {
          if (array == 'status' && this.vistoria == true) {
            if (
              element[campoPK] == 3 ||
              element[campoPK] == 4 ||
              element[campoPK] == 5
            )
              this[array].push({
                id: element[campoPK],
                label: element[campoDescricao],
              });
          } else
            this[array].push({
              id: element[campoPK],
              label: element[campoDescricao],
            });
        });
      });
    },
    buscaRateios() {
      service
        .getAll('Rateios', {}, 'list/idEmpresa=' + this.idEmpresa)
        .then((res) => {
          res.data.forEach((element) => {
            if (element.dataFinalizacao)
              this.rateios.push({
                id: element.idRateio,
                label: element.mesReferenciaBoleto,
              });
          });
        });
    },
    buscaStatusBoletos() {
      service
        .post('Status', 'listStatusBoletosRegistrosFinanceiros', {})
        .then((res) => {
          res.data.forEach((element) => {
            this.statusCobranca.push({
              id: element.id_staus,
              label: element.nomeStatus + ' - ' + element.origem,
              nomeStaus: element.nomeStatus,
              origem: element.origem,
            });
          });
        });
    },
    buscaStatusVeiculosAssociados() {
      var objSend = {};
      objSend.idEmpresa = this.idEmpresa;
      objSend.notDeleted = true;
      service.post('status', 'list', objSend).then((res) => {
        if (res.data.length > 0) {
          res.data.forEach((element) => {
            if (element.tipoStatus == 'VEÍCULOS')
              this.statusVeiculo.push({
                id: element.idStatus,
                label: element.nomeStatus,
              });

            if (element.tipoStatus == 'ASSOCIADOS')
              this.statusAssociado.push({
                id: element.idStatus,
                label: element.nomeStatus,
              });
          });
        }
      });
    },
    buscaFormasdePagamento() {
      var objSend = {};
      objSend.idEmpresa = this.idEmpresa;
      service
        .post('CarteiraCobranca', 'buscaFormasPagamentoDisponiveis', objSend)
        .then((res) => {
          res.data.forEach((element) => {
            this.formasPagamento.push({
              id: element.id_tipoPagamentoEmpresa,
              label: element.nomePagamento,
            });
          });
        });
    },
    buscaDadosSelectsCidades(model, array, campoDescricao, campoPK) {
      this.$vs.loading();
      this[array] = [];
      service
        .getAll('g', {}, `${model}/list/codUf/${this.formFiltro.estado.id}`)
        .then((res) => {
          res.data.forEach((element) => {
            this[array].push({
              id: element[campoPK],
              label: element[campoDescricao],
            });
          });

          this.$vs.loading.close();
        });
    },
    buscar() {
      this.formFiltro.idEmpresa = this.idEmpresa;
      this.formFiltro.filtred = true;
      this.$emit('filtro', this.formFiltro);
    },
    buscaTiposBoletos() {
      service.getAll('boletos', {}, `buscar-tipos-boletos`)
      .then(({ data }) => {
        data.forEach((element) => {
          element.id = element.idTipoBoleto;
          element.label = element.tipoBoleto;
          this.tiposBoletos.push(element);
        });
      });
    },
    async buscaFiltrosAvancados() {
      try {
        this.$vs.loading();

        await service.post('cotacao', 'busca-filtros-consultores-regionais', this.decoded)
        .then(({ data }) => {
          this.consultores = [];
          data.consultores.forEach((element) => {
            this.consultores.push({
              id: element.id_usuario,
              label: element.nome
            });
          });

          this.regionais = [];
          data.regionais.forEach((element) => {
            this.regionais.push({
              id: element.idRegional,
              label: element.nome
            });
          });
        });
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Falha ao buscar filtros',
          text: error,
          color: 'danger',
        });
      } finally {
        this.$vs.loading.close();
      };
    },
    getDecoded() {
      const token = localStorage.getItem('user-token');
      if (token) {
        this.decoded = jwt.decode(token);
      }

      this.idEmpresa = this.decoded.id_empresa;
      this.id_usuario = this.decoded.id_usuario;
    },
  },
  created() {
    this.getDecoded();
  },
  mounted() {
    this.buscaRateios();
    this.buscaStatusVeiculosAssociados();
    this.buscaFormasdePagamento();
    this.buscaStatusBoletos();
    this.buscaFiltrosAvancados();
    this.buscaTiposBoletos();
    this.$validator.localize('ptBr', locale);
  },
  components: {
    Datepicker,
    'v-select': vSelect,
    AutoComplete
  },
};
</script>
<!------------ END SCRIPT ------------>
<style>
.vs__dropdown-toggle {
  padding: 4px 0 6px 0 !important;
}

.vdp-datepicker input {
  width: 100%;
}

.vdp-datepicker__calendar {
  z-index: 900 !important;
}
</style>
